<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules"
        :loading="loading"
        @reset="reset">
      <vxe-form-item span="24">
        <template>
          <div class="title">
            <div class="block"></div>
            <span>基本信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船名" field="shipName" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.shipName" :readonly="readOnly"
                     :placeholder="readOnly ? '':'请输入船名'"
                     :clearable="!readOnly" @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="MMSI" field="mmsi" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.mmsi" :readonly="readOnly"
                     :placeholder="readOnly ? '':'请输入MMSI'"
                     :clearable="!readOnly"
                     type="number" @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="载重吨" field="deadweight" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.deadweight" :readonly="readOnly"
                     :placeholder="readOnly ? '':'请输入载重'"
                     :clearable="!readOnly"
                     type="number" @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶种类" field="shipType" span="8">
        <template>
          <Select v-model="formData.shipType" v-if="!readOnly" transfer>
            <Option v-for="(item,index) in ship_type" :value="item.label" :key="index">{{ item.label }}</Option>
          </Select>
          <span v-else>{{ formData.shipType }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶所有人" field="shipOwner" span="8">
        <template v-slot>
          <vxe-input class="rowInput" v-model="formData.shipOwner" :placeholder="readOnly ? '':'请输入船舶所有人'"
                     :clearable="!readOnly"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24">
        <template>
          <div class="title">
            <div class="block"></div>
            <span>船舶证件</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="营运证所有人(电子营运证)" field="licenseUuidList" span="8" class="imgBox">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/yyzsyr.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="license"
                :initFileList="licenseUuidList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="营运证吨位" field="licenseTonUuidList" span="8" class="imgBox">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/yyzdw.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="licenseTon"
                :initFileList="licenseTonUuidList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶国籍证书" field="shipNationUuidList" span="8" title-width="120" class="imgBox">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/cbgjzs.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="shipNation"
                :initFileList="shipNationUuidList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶所有权" field="ownerUuidList" span="8" class="imgBox">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/cbsyq.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="owner"
                :initFileList="ownerUuidList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="安全环保记录(船舶主要项目)" field="shipMainProImgList" span="8" class="imgBox">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/aqhbjl.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="shipMainProImg"
                :initFileList="shipMainProImgList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶电台执照(AIS标识码证书)" field="trUuidList" span="8" class="imgBox" title-width="120">
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center;margin-right: 5px"
            >
              <img class="exp" src="@/assets/images/common/cbdtzz.png" v-image-preview/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-list
                :width="80"
                :height="80"
                :isEdit="!readOnly"
                :row="tr"
                :initFileList="trUuidList"
                :view="'arrange'"
                :max-length="1"
            ></upload-list>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24">
        <template>
          <div class="title">
            <div class="block"></div>
            <span>船舶图片</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶图片" field="imageList" span="24" class="imgBox">
        <template>
          <upload-list
              :width="80"
              :height="80"
              :isEdit="!readOnly"
              :row="image"
              :initFileList="imageList"
              :view="'arrange'"
          ></upload-list>
        </template>
      </vxe-form-item>
      <vxe-form-item align="right" span="24">
        <template>
          <vxe-button v-if="readOnly && formData.authStatus === 1" type="submit" @click="goAuth">审核</vxe-button>
          <vxe-button
              v-if="readOnly && (formData.authStatus === 0 || formData.authStatus === 1 || formData.authStatus === 2)"
              type="submit" status="primary" @click="showUpdate">编辑
          </vxe-button>
          <vxe-button
              v-if="!readOnly && (formData.authStatus === 0 || formData.authStatus === 1 || formData.authStatus === 2)"
              type="submit" status="primary" @click="commit">确定
          </vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="authModal" title="审核菜单" width="600" height="300" @close="authModal = false" resize
               position="center"
               destroy-on-close>
      <ship-auth @afterAuth="afterAuth" @close="authModal = false" ref="authModal"></ship-auth>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider';
import {hideLoading, showLoading} from '@/utils/util';
import UploadList from '@/components/common/UploadList';
import ShipAuth from "@/views/userCarShip/shipAuth";

export default {
  components: {UploadList, ShipAuth},
  data() {
    return {
      authModal: false,
      formData: {
        id: '',
        buildTime: null,
        deadweight: null,
        homePort: [],
        loadDraught: null,
        mmsi: null,
        netweight: null,
        shipLength: null,
        shipName: '',
        shipType: null,
        shipWidth: null,
        totalweight: null,
        linkMan: '',
        linkPhone: '',
        remark: null,
        status: 1,
        isCopy: null,
        authStatus: null,
        licenseList: [],
        ownerList: [],
        licenseTonList: [],
        shipNationList: [],
      },
      loading: false,
      timer: null,
      intervalTime: 0,
      licenseUuidList: [],
      licenseTonUuidList: [],
      ownerUuidList: [],
      shipNationUuidList: [],
      ortherUuidList: [],
      shipMainProImgList: [],
      trUuidList: [],
      imageList: [],
      image: {},
      tr: {},
      shipMainProImg: {},
      license: {},
      licenseTon: {},
      shipNation: {},
      owner: {},
      orther: {},
      shipData: [],
      formRules: {
        mmsi: [
          {required: true, message: "请输入MMSI"},
          {min: 9, max: 9, message: '请输入9位数字'}
        ],
        shipName: [
          {required: true, message: "请输入船名"},
        ],
        deadweight: [
          {required: true, message: "请输入载重"},
        ],
      },
      readOnly: false,
      ship_type: [],
      home_port: [],
      ptShip: {},
      dict: []
    }
  },
  mounted() {
    this.getDictByCode(40600, "ship_type");
  },
  methods: {
    goAuth() {
      this.authModal = true;
      this.$nextTick(() => {
        this.$refs.authModal.init(this.formData.id);
      })
    },
    afterAuth() {
      this.authModal = false;
      this.$emit('afterSave');
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getTypeByCode(arr, code) {
      let that = this;
      this.dict.map(i => {
        if (i.dictCodeP === code) {
          let obj = {
            label: i.dictText,
            value: i.dictCode,
            children: [],
          }
          that.dict.map(j => {
            if (j.dictCodeP === i.dictCode) {
              obj.children.push({
                label: j.dictText,
                value: j.dictCode,
              })
            }
          })
          // if (obj.children.length === 0) {
          //   obj.disabled = true;
          // }
          arr.push(obj);
        }
      })
      return arr;
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    setReadOnly() {
      this.readOnly = true;
      let dom = Array.from(document.getElementsByClassName('rowInput'));
      dom.map(i => {
        i.childNodes[0].style.border = 'none';
      })
    },
    showUpdate() {
      this.$emit('update');
      this.readOnly = false;
      let dom = Array.from(document.getElementsByClassName('rowInput'));
      dom.map(i => {
        i.childNodes[0].style.border = '';
      })
    },
    setUpdate(row) {
      this.queryDetail(row.id);
      // this.formData = Object.assign({}, row);
      // this.licenseUuidList = row.licenseList;
      // this.licenseTonUuidList = row.licenseTonList;
      // this.ownerUuidList = row.ownerList;
      // this.shipNationUuidList = row.shipNationList;
      // this.ortherUuidList = row.ortherList;
      // this.shipMainProImgList = row.shipMainProImgList;
      // this.trUuidList = row.trUuidList;
      // this.imageList = row.imageList;
    },
    async queryDetail(carShipId) {
      let res = await $api.carShip.request("queryShipDetailNew", {id: carShipId});
      if (res.status === 1) {
        this.formData = Object.assign({}, res.data);
        if (this.formData.buildTime) {
          this.formData.buildTime = this.$utils.toStringDate(this.formData.buildTime);
        }

        this.licenseUuidList = res.data.licenseList;
        this.licenseTonUuidList = res.data.licenseTonList;
        this.ownerUuidList = res.data.ownerList;
        this.shipNationUuidList = res.data.shipNationList;
        this.ortherUuidList = res.data.ortherList;
        this.shipMainProImgList = res.data.shipMainProImgList;
        this.trUuidList = res.data.trUuidList;
        this.imageList = res.data.imageList;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }

      let obj = Object.assign({}, this.formData);
      if (obj.shipName) {
        obj.shipName = obj.shipName.trim();
      }
      if (obj.mmsi) {
        obj.mmsi = obj.mmsi.trim();
      }
      obj.licenseUuidList = this.license.fileUuidList;
      obj.licenseTonUuidList = this.licenseTon.fileUuidList;
      obj.shipNationUuidList = this.shipNation.fileUuidList;
      obj.ownerUuidList = this.owner.fileUuidList;
      obj.ortherUuidList = this.orther.fileUuidList;
      obj.shipMainProImgList = this.shipMainProImg.fileUuidList;
      obj.trUuidList = this.tr.fileUuidList;
      obj.imageList = this.image.fileUuidList;

      this.update(obj)
    },
    async update(obj) {
      showLoading();
      let res = await $api.carShip.request('updateShip', obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.reset();
        this.$emit('afterSave', 'afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reset() {
      this.formData = {
        id: '',
        buildTime: null,
        deadweight: null,
        homePort: [],
        loadDraught: null,
        mmsi: null,
        netweight: null,
        shipLength: null,
        shipName: '',
        shipType: null,
        shipWidth: null,
        totalweight: null,
        linkMan: null,
        linkPhone: null
      };
      this.ptShip = {};
      this.shipData = [];
      this.licenseUuidList = [];
      this.licenseTonUuidList = [];
      this.shipNationUuidList = [];
      this.ownerUuidList = [];
      this.ortherUuidList = [];
      this.shipMainProImgList = [];
      this.trUuidList = [];
      this.imageList = [];
      this.$emit('close');
    },
  }
}
</script>

<style scoped>
.block {
  display: flex;
  align-items: center;
}

.block-tip {
  width: 4px;
  height: 16px;
  background: #539FFF;
}

.block-title {
  margin-left: 4px;
  height: 21px;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  color: #539FFF;
}

.ivu-auto-complete.ivu-select-dropdown {
  z-index: 5000 !important;
}

.rowInput .vxe-input--extra-suffix {
  display: none;
}

.checkItem {
  padding: 0 !important;
  height: 19px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #ED4014;
}

.checkItem .vxe-form--item-inner {
  min-height: 19px;
}

.title {
  display: flex;
  align-items: center;
}

.block {
  width: 4px;
  height: 14px;
  background: #438DF3;
}

.title span {
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: bold;
  color: #438DF3;
  margin-left: 6px;
}

.imgBox {
  height: 110px;
  display: flex !important;
  align-items: center;
}

.imgBox >>> .vxe-form--item-title {
  white-space: normal;
}

.exp {
  width: 56px;
  height: 80px;
}


</style>